import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import CurrentPrice from '../display-price/current-price'
import ListPrice from '../display-price/list-price'
import Discount from '../display-price/discount'
import InfoPopover from '../popovers/info-popover'
import {remCalc} from '../../theme/_utils'
import {InfoIcon} from '../icons'
import OmnibusPrice from '../display-price/omnibus-price'

const ProductPrice = ({priceData, currency, notShoppableCountry, variant}) => {
    const styles = useMultiStyleConfig('ProductPrice', {variant})

    const {listPrice, currentPrice, isASet, isMaster, isOnSale, isRange} = priceData || {}

    const intl = useIntl()
    if (notShoppableCountry || !priceData) {
        return null
    }

    const currentPriceIsRange = isASet ? true : Boolean(isMaster && isRange)
    const listPriceIsRange = Boolean(isMaster && isRange)
    const showOriginalPrice = isOnSale && Boolean(listPrice)
    const discountPrice =
        showOriginalPrice && listPrice > 0 ? (listPrice - currentPrice) / listPrice : undefined

    return (
        <Flex {...styles.pricingOuterContainer}>
            <Flex {...styles.pricingInnerContainer}>
                <CurrentPrice
                    price={currentPrice}
                    as="b"
                    currency={currency}
                    isRange={currentPriceIsRange}
                    {...styles.currentPrice}
                />
                {showOriginalPrice && (
                    <ListPrice
                        price={listPrice}
                        currency={currency}
                        isRange={listPriceIsRange}
                        showSuggestedLabel={false}
                        {...styles.listPrice}
                    />
                )}
                {discountPrice !== undefined && (
                    <Discount price={discountPrice} {...styles.discount} />
                )}
                {isOnSale ? (
                    <InfoPopover
                        trigger={
                            <Flex flexDir="column" alignItems="flex-start">
                                <InfoIcon
                                    aspectRatio="1/1"
                                    width={remCalc(16)}
                                    height={remCalc(16)}
                                    color="foreground.neutral.default"
                                />
                            </Flex>
                        }
                        variant="top-left-no-y-offset"
                        openTooltipOn="click"
                        title={intl.formatMessage({
                            id: 'price_card.info.popover.title',
                            defaultMessage: 'PriceCard Popover Title',
                        })}
                        description={intl.formatMessage({
                            id: 'price_card.info.popover.description',
                            defaultMessage: 'PriceCard Popover Description',
                        })}
                    />
                ) : (
                    <></>
                )}
            </Flex>

            <Flex width="auto" alignItems="center" gap="xxxsmall-1.base" wrap="wrap">
                {priceData.showOmnibusPrice && (
                    <OmnibusPrice
                        priceData={priceData}
                        currency={currency}
                        omnibusExpandedView={false}
                        variant={variant}
                    />
                )}
            </Flex>
        </Flex>
    )
}

ProductPrice.propTypes = {
    priceData: PropTypes.shape({
        currentPrice: PropTypes.number,
        isOnSale: PropTypes.bool,
        listPrice: PropTypes.number,
        isASet: PropTypes.bool,
        isMaster: PropTypes.bool,
        isRange: PropTypes.bool,
        showOmnibusPrice: PropTypes.bool,
        taxRate: PropTypes.number,
    }),
    currency: PropTypes.string,
    notShoppableCountry: PropTypes.bool,
    variant: PropTypes.string,
}

export default ProductPrice
